import { PO_DEV_URL } from './constants';

const isLocalhost = () => window.location.hostname.includes('localhost');

/** Path on the Identity portal where citizens manage data shared with portals. */
const IDENTITY_UDAJE_PATH = 'obcan/moje-udaje';

/**
 * Deeplink to the citizen's "data shared with other portals" section on the
 * Identity portal, built from the configured base URL. Rendered as a markdown
 * link in the SMS subtitles; MarkdownRender opens external URLs in a new tab so
 * the authorization dialog is not closed.
 */
export const buildIdentityUdajeUrl = (identitaObcanaUrl: string) => {
	const base = (identitaObcanaUrl ?? '').replace(/\/+$/, '');
	return `${base}/${IDENTITY_UDAJE_PATH}`;
};

/** SPA route NIA returns to; the dev bounce appends the Id/Result params. */
const AUTORIZACE_RESULT_PATH = 'autorizace/vysledek';

/**
 * Localhost cannot finish the NIA browser leg directly: NIA only accepts the
 * registered dev ReplyUrl, so it returns to the dev cluster and the local
 * session never sees the result. Instead we reuse the dev `/authz/start` cookie
 * bounce — it starts NIA with the registered ReplyUrl but records our localhost
 * `redirect-url`, so the dev nginx 302s the result back to localhost.
 *
 * Same contract as mobile's authz-start URL: raw scheme for `nia-url` and
 * `redirect-url`, only `id` is encoded. Enabled only on localhost, so deployed
 * environments are unaffected.
 */
const buildLocalhostAuthzStartUrl = (
	niaAuthorizaitionUrl: string,
	ukonId: string
) => {
	const redirectUrl = `${window.location.origin}/${AUTORIZACE_RESULT_PATH}`;
	return `${PO_DEV_URL}/authz/start?nia-url=${niaAuthorizaitionUrl}&id=${encodeURIComponent(
		ukonId
	)}&redirect-url=${redirectUrl}`;
};

export const getRedirectUrl = (
	niaAuthorizaitionUrl: string,
	ukonId: string
) => {
	// On localhost, bounce through the dev cookie mechanism so the result comes
	// back to the local session; deployed environments keep the direct NIA path.
	if (isLocalhost()) {
		return buildLocalhostAuthzStartUrl(niaAuthorizaitionUrl, ukonId);
	}

	const sp = new URLSearchParams({
		Id: ukonId,
		// ReplyUrl is registered in NIA and handled by nginx, not a SPA route
		ReplyUrl: `${window.location.origin}/autorizace`,
	});

	return `${niaAuthorizaitionUrl}?${sp.toString()}`;
};
